import {
  ACT_TAGS_FETCH_INIT,
  ACT_TAGS_FETCH_200,
} from '../constants/actions';

export const fetchTagsInitAction = () => ({
  type: ACT_TAGS_FETCH_INIT,
});

export const fetchTagsSuccessAction = data => ({
  type: ACT_TAGS_FETCH_200,
  payload: data,
});
